import { useParams } from 'react-router-dom'

import { useSiteOperatorGetApi } from '@/common/api/modules/siteOperator'
import { useSiteId } from '@/common/app/site'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import SiteOperatorEditPage from '@/components/container/page/site/setting/operator/SiteOperatorEditPage'

const SiteOperatorUpdatePage = () => {
  const siteId = useSiteId()
  const { operatorId } = useParams()

  const { data, error, mutate } = useSiteOperatorGetApi({
    site_id: siteId,
    operator_id: Number(operatorId)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <SiteOperatorEditPage operator={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default SiteOperatorUpdatePage
